'use strict';

var processInclude = require('base/util');

processInclude(require('./accordion'));
processInclude(require('./miniCart'));
processInclude(require('./swatchSelector'));
processInclude(require('./spinner'));
processInclude(require('./search'));
processInclude(require('./dropdownOver'));
processInclude(require('./anchorLink'));
processInclude(require('./quantitySelector'));
processInclude(require('./pickupInStore')); //PWC-NOA-310 Checkout shipping and billing step
processInclude(require('./shareLink'));
processInclude(require('./giftcard')); //PWC-NOA-466 integrate givex for gift card